import { defaultCompany } from "redux/Me/meSlice";

export const API_ENDPOINTS = {
  register: "register",
  login: "login",
  cms: "website/cms",
  Category: "get-category",
  PopularProduct: "get-popular-products",
  // itemMaster: "get-popular-products",
  itemMasterByID: "get-product",
  itemMaster: "get-products",
  Banner: "/herosection/get-all",
  Categories: "/category/get-all",
  ProductByCategory: "get-product-by-category",
  ProductBySlug: "/getProductBySlug",
  PageBySlug: "/getPageBySlug",
  Settings: "/getSettingData",
  SalesOrder: "sales/sales-order",
  SalesOrderByUuid: "sales/sales-order/order",
  SalesOrderList: "sales/sales-order/my-orders",
  Me: "auth/me",
  UpdateProfile: "auth/update-profile",
  hrUserAddress: "hr/UserAddress",
  defaultCompany: "setup/default-company",
  // // Razorpay endpoints
  // RazorpayCreateOrder: "razorpay/create-order",
  // RazorpayVerifyPayment: "razorpay/verify-payment",
  // RazorpayPaymentStatus: "razorpay/payment-status",
};
